<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
      <v-card-title primary-title class="text-subtitle-1">
        Calendario de pagos
      </v-card-title>
      <v-card-text class="black--text">

        <v-row>
          <v-col cols="12" lg="4" md="6">
            <v-autocomplete
              v-model="tipoDeCurso"
              :items="filteredTiposCurso"
              item-text="label"
              item-value="value"
              label="Selecciona un tipo de curso"
              outlined
              :disabled="!escuela"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
            @click="downloadImage()"
          >
            Descargar
            <v-icon
              right
              dark
            >
              mdi-cloud-download
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-row  dense>
          <v-col cols="12">
            <v-img :src="url" contain ></v-img>
          </v-col>
        </v-row>

        <v-divider></v-divider>
      </v-card-text>
    </v-card>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import axios from 'axios';

  import { mapGetters, mapActions }    from "vuex";

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      edad: null,
      modalidad: null,
      horario: null,
      hermanos: null,

      promociones: [],
      escuela: 1,
      tipoDeCurso: null,
      tiposCurso: [
          { label: 'Adults - Regular'                      , value: 1,  escuela: 1, filename: 'Adults.jpg' },
          { label: 'Adults - Regular - Hermanos'           , value: 24, escuela: 1, filename: 'Adults beca de hermanos.jpg' },
          { label: 'Adults - Regular - Sabatino'           , value: 9,  escuela: 1, filename: 'Adults sabatino.jpg' },
          { label: 'Adults - Regular - Sabatino - Hermanos', value: 17, escuela: 1, filename: 'Adults sabatino beca de hermanos.jpg' },

          { label: 'Adults - Online'                      , value: 3,  escuela: 1, filename: 'Online2.jpg' },
          { label: 'Adults - Online - Hermanos'           , value: 23, escuela: 1, filename: 'Online beca de hermanos2.jpg' },
          { label: 'Adults - Online - Sabatino'           , value: 11, escuela: 1, filename: 'Online sabatino2.jpg' },
          { label: 'Adults - Online - Sabatino - Hermanos', value: 18, escuela: 1, filename: 'Online sabatino beca de hermanos2.jpg' },

          { label: 'Teens - Regular'                      , value: 5,  escuela: 1, filename: 'Teens.jpg' },
          { label: 'Teens - Regular - Hermanos'           , value: 25, escuela: 1, filename: 'Teens beca de hermanos.jpg' },
          { label: 'Teens - Regular - Sabatino'           , value: 13, escuela: 1, filename: 'Teens sabatino.jpg' },
          { label: 'Teens - Regular - Sabatino - Hermanos', value: 19, escuela: 1, filename: 'Teens sabatino beca de hermanos.jpg' },
          
          { label: 'Kids - Regular'                      , value: 21, escuela: 1, filename: 'Kids.jpg' },
          { label: 'Kids - Regular - Hermanos'           , value: 22, escuela: 1, filename: 'Kids beca de hermanos.jpg' },

          { label: 'Intensivo - Regular'                      , value: 2,  escuela: 2, filename: 'Intensivo.jpg' },
          { label: 'Intensivo - Regular - Hermanos'           , value: 6,  escuela: 2, filename: 'Intensivo beca de hermanos.jpg' },
          { label: 'Intensivo - Regular - Sabatino'           , value: 10, escuela: 2, filename: 'Intensivo sabatino.jpg' },
          { label: 'Intensivo - Regular - Sabatino - Hermanos', value: 14, escuela: 2, filename: 'Intensivo sabatino beca de hermanos.jpg' },

          { label: 'Intensivo - Online'                       , value: 4,  escuela: 2, filename: 'Online.jpg' },
          { label: 'Intensivo - Online - Hermanos'            , value: 8,  escuela: 2, filename: 'Online beca de hermanos.jpg' },
          { label: 'Intensivo - Online - Sabatino'            , value: 12, escuela: 2, filename: 'Online sabatino.jpg' },
          { label: 'Intensivo - Online - Sabatino - Hermanos' , value: 16, escuela: 2, filename: 'Online sabatino beca de hermanos.jpg' }
        ]

    }),

    created( ){

      this.escuela = this.getEscuela

      this.initialize( )
    },

    methods:{

      initialize( ){
        this.cargar = true;
        this.promociones = [];
        this.$http.get("promociones.imagenes").then((response) => {
          this.promociones = response.data
          console.log( this.promociones )
          this.cargar = false;
        }).catch((error) => {
          this.validarError(error);
        }).finally(() => {
          this.cargar = false;
        });
      },

      async downloadImage() {

        // const curso = this.tiposCurso.find(item => item.value == this.tipoDeCurso);

        // if (curso) {
        //   const downloadUrl = `https://escuelakpi.club/kpi/download-imagenes/imagenes-promociones/${curso.filename}`;
        //   window.location.href = downloadUrl;
        // }

        
      },

    },

    computed:{
      ...mapGetters('login',['getEscuela','getCCNNUsuario']),

      filteredTiposCurso() {
        console.log( this.escuela )
        // Filtrar los cursos según la escuela seleccionada
        return this.tiposCurso.filter(item => item.escuela == this.escuela);
      },

      url () {
        // Validar si hay un tipo de curso seleccionado
        const curso = this.tiposCurso.find(item => item.value == this.tipoDeCurso);
        if (curso) {
          // return 'https://escuelakpi.club/kpi/imagenes-promociones/' + curso.filename;
        }
        return '';
      },

      
    },

    watch: {
      // Cuando cambia la escuela, limpiar la selección del tipo de curso
      escuela() {
        this.tipoDeCurso = null;
      }
    }
  }
</script>

<style>
  body {
  margin: 0;
  font-family: sans-serif;
  font-size: 0.9rem;
}
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
#toolbar {
  display: flex;
  align-items: center;
  background-color: #555;
  color: #fff;
  padding: 0.5em;
}
#toolbar button,
#page-mode input {
  color: currentColor;
  background-color: transparent;
  font: inherit;
  border: 1px solid currentColor;
  border-radius: 3px;
  padding: 0.25em 0.5em;
}
#toolbar button:hover,
#toolbar button:focus,
#page-mode input:hover,
#page-mode input:focus {
  color: lightGreen;
}
#page-mode {
  display: flex;
  align-items: center;
  padding: 0.25em 0.5em;
}

#viewport-container {
  flex: 1;
  background: #eee;
  overflow: auto;
}


#viewport {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
#viewport > div {
  text-align: center;
  max-width: 100%;
}
#viewport canvas {
  width: 100%;
  box-shadow: 0 2px 5px gray;
}

#viewerContainer::-webkit-scrollbar {
  -webkit-appearance: none !important;
}

.#viewerContainer > #viewerContainer::-webkit-scrollbar:vertical {
  width: 8px !important;
}

#viewerContainer::-webkit-scrollbar:vertical{
  width: 8px !important;
}

#viewerContainer::-webkit-scrollbar-thumb{
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

</style>
